// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"262":"c485dcdd","366":"64e7db85"}[chunkId] + ".chunk.css";
};